import { ExamineeDetails } from "@fadmin/tabs/assessments/store/newExamineeSlice";
import { ExistingExamineeDetails } from "@store/generalTypes";
import { differenceInYears, parseISO } from "date-fns";
import { getDatePartsISO8601 } from "./dateHelpers";

export const getDetails = (examinee: ExistingExamineeDetails): ExamineeDetails => {
    const { day, month, year } = getDatePartsISO8601(examinee.birthDate);
    return {
        ethnicity: examinee.ethnicity,
        sex: examinee.sex,
        primaryLanguage: examinee.primaryLanguage,
        birthDay: day,
        birthMonth: month,
        birthYear: year,
        race: examinee.race,
        highestLevelEducation: examinee.highestLevelEducation,
        secondaryLanguages: examinee.secondaryLanguages ?? []
    };
};

export const getAgeFromBirthdate = (birthDate: string): number => {
    return differenceInYears(new Date(), parseISO(birthDate));
};
